import { use } from "react";

import { WhitelabelBrandContext } from "@/providers/whitelabelBrandConfig";

export function useWhitelabelBrand() {
  const appBaseUrl = location.origin;
  const whitelabelBrand = use(WhitelabelBrandContext);
  return { whitelabelBrand, appBaseUrl };
}
